import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function FetchAmazonNotificationIssuesService(token, data) {
    return axios
        .post(
            `${CURRENT_API_URL}/amazonNotifications/fetchAmazonNotificationIssues`,
            data,
            {
                headers: {
                    Authorization: token,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.log(error);
            notify.NotifyError(
                "An error occurred while fetching notification issues. Please try again later."
            );
            return false;
        });
}

export default FetchAmazonNotificationIssuesService;
